import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faMoneyBill,
  faFragile,
  faExpandAlt,
  faBoxOpen,
  faFileWord,
  faWeightScale,
  faChevronDown,
  faChevronRight,
  faHouse,
  faTruck,
  faUser,
  faHourglass,
  faCheck,
  faCheckSquare,
  faDownload,
  faArrowLeft,
  faTruckLoading,
  faPlus,
  faTrashAlt,
  faBan,
  faUndo,
  faTriangleExclamation,
  faTimes,
  faSignInAlt,
  faCheckDouble,
  faTruckRamp,
  faNote,
  faSend,
  faPrint,
  faUpload,
  faTag,
  faListSquares,
  faChevronCircleUp,
  faChevronCircleDown,
  faHouseBuilding,
  faCalendarDays,
  faWarehouseAlt,
  faCashRegister,
  faGlobe,
  faSearch,
  faShippingFast,
  faChartPieAlt,
  faFilter,
  faRecycle,
  faClockRotateLeft,
  faBoxes,
  faCog,
  faSignOutAlt,
  faMinus,
  faX,
  faListCheck,
  faTruckFast as faTruckFastRegular,
  faNotebook,
  faInfoCircle,
  faFolders,
  faChevronCircleRight,
  faHouseBuilding as faHouseBuildingRegular,
  faWarehouseAlt as faWarehouseAltRegular,
  faCashRegister as faCashRegisterRegular,
  faGlobe as faGlobeRegular,
  faSearch as faSearchRegular,
  faCartPlus,
  faConveyorBelt,
  faBoxFull,
  faPalletAlt,
  faCheckCircle,
  faExclamationTriangle,
  faRectangleHistoryCirclePlus,
  faCamera,
  faCircle,
  faSave,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faPen,
  faXmark,
  faArrowsUpDownLeftRight,
  faRotateRight,
  faTrash,
  faTruckFast,
  faWeightHanging,
  faArrowsLeftRight,
  faArrowsUpDown,
  faArrowDownToArc,
  faArrowDown,
  faReceipt as faReceiptSolid,
  faCalendar,
  faUserVneck,
  faArrowUpRightFromSquare,
  faFloppyDisk,
  faCheck as faCheckSolid,
} from '@fortawesome/pro-solid-svg-icons'
import { faReceipt, faBox, faBoxCircleCheck, faWarehouseFull, faDolly } from '@fortawesome/pro-duotone-svg-icons'

// Add only the icons we use to the library
library.add(
  // Regular icons
  faMoneyBill,
  faFragile,
  faExpandAlt,
  faBoxOpen,
  faFileWord,
  faWeightScale,
  faChevronDown,
  faChevronRight,
  faHouse,
  faTruck,
  faUser,
  faHourglass,
  faCheck,
  faCheckSquare,
  faDownload,
  faArrowLeft,
  faTruckLoading,
  faPlus,
  faTrashAlt,
  faBan,
  faUndo,
  faTriangleExclamation,
  faTimes,
  faSignInAlt,
  faCheckDouble,
  faTruckRamp,
  faNote,
  faSend,
  faPrint,
  faUpload,
  faTag,
  faListSquares,
  faChevronCircleUp,
  faChevronCircleDown,
  faHouseBuilding,
  faCalendarDays,
  faWarehouseAlt,
  faCashRegister,
  faGlobe,
  faSearch,
  faShippingFast,
  faChartPieAlt,
  faFilter,
  faRecycle,
  faClockRotateLeft,
  faBoxes,
  faCog,
  faSignOutAlt,
  faMinus,
  faX,
  faListCheck,
  faTruckFastRegular,
  faNotebook,
  faInfoCircle,
  faFolders,
  faChevronCircleRight,
  faHouseBuildingRegular,
  faWarehouseAltRegular,
  faCashRegisterRegular,
  faGlobeRegular,
  faSearchRegular,
  faCartPlus,
  faConveyorBelt,
  faBoxFull,
  faPalletAlt,
  faCheckCircle,
  faExclamationTriangle,
  faRectangleHistoryCirclePlus,
  faCamera,
  faSave,
  // Solid icons
  faPen,
  faXmark,
  faArrowsUpDownLeftRight,
  faRotateRight,
  faTrash,
  faTruckFast,
  faWeightHanging,
  faArrowsLeftRight,
  faArrowsUpDown,
  faArrowDownToArc,
  faArrowDown,
  faReceiptSolid,
  faCalendar,
  faUserVneck,
  faArrowUpRightFromSquare,
  // Duotone icons
  faReceipt,
  faBox,
  faBoxCircleCheck,
  faWarehouseFull,
  faDolly,
  faFloppyDisk,
)
